/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    handle: "handle",
    handleSelected: "handle--selected",
};
export const ICONS = {
    drag: "drag",
};
export const SUBSTITUTIONS = {
    itemLabel: "{itemLabel}",
    position: "{position}",
    total: "{total}",
};
//# sourceMappingURL=resources.js.map
